// extracted by mini-css-extract-plugin
module.exports = {"notification":"TouchpointNotifications_notification__DUbJo","message-only":"TouchpointNotifications_message-only__LRX3n"};